import Vue from 'vue'

// 使用 Event 事件传输
const transmit = new Vue()

export default transmit



// WEBPACK FOOTER //
// ./src/components/common/transmit.js